/**
 * Header state machine — exact port of Navbar.tsx behavior:
 * - scrolled = y > 10; hide on scroll-down past 10px, show on ANY scroll-up
 * - hiding closes overlay + drawer
 * - isWhite = forcedLight || searchFocused || overlayOpen || scrolled
 * - Escape closes everything
 * - body scroll locked while overlay or drawer is open
 * - mega overlay: click toggles; group switch = 120ms crossfade
 *   (panelVisible false → 120ms → swap group, panelVisible true)
 * - search stays expanded while it contains text
 */
(function () {
  'use strict';

  var header = document.querySelector('[data-site-header]');
  if (!header) return;

  var backdrop = document.querySelector('[data-mega-backdrop]');
  var megaMenu = document.querySelector('[data-mega-menu]');
  var megaPanel = document.querySelector('[data-mega-panel]');
  var megaToggle = header.querySelector('[data-mega-toggle]');
  var groupButtons = megaMenu ? Array.prototype.slice.call(megaMenu.querySelectorAll('[data-mega-group]')) : [];
  var panes = megaPanel ? Array.prototype.slice.call(megaPanel.querySelectorAll('[data-mega-pane]')) : [];
  var searchInput = header.querySelector('[data-header-search-input]');
  var drawer = document.querySelector('[data-mobile-drawer]');
  var drawerBackdrop = document.querySelector('[data-mobile-backdrop]');
  var drawerOpenBtn = header.querySelector('[data-drawer-open]');
  var mobileSearchBtn = header.querySelector('[data-mobile-search-open]');
  var mobileSearch = document.querySelector('[data-mobile-search]');
  var mobileSearchInput = mobileSearch ? mobileSearch.querySelector('[data-mobile-search-input]') : null;
  var mobileSearchCloseBtn = mobileSearch ? mobileSearch.querySelector('[data-mobile-search-close]') : null;
  var drawerCloseBtn = drawer ? drawer.querySelector('[data-drawer-close]') : null;
  var drawerBackBtn = drawer ? drawer.querySelector('[data-drawer-back]') : null;
  var drawerGroupBtns = drawer ? Array.prototype.slice.call(drawer.querySelectorAll('[data-drawer-group]')) : [];
  var drawerPanes = drawer ? Array.prototype.slice.call(drawer.querySelectorAll('[data-drawer-pane]')) : [];

  var transparent = header.getAttribute('data-transparent') === 'true';

  var scrolled = window.scrollY > 10;
  var visible = true;
  var searchFocused = false;
  var overlayOpen = false;
  var activeGroupId = null;
  var panelVisible = false;
  var mobileOpen = false;
  var mobileGroupId = null;
  var mobileSearchOpen = false;
  var lastScrollY = window.scrollY;
  var panelTimer = null;

  function render() {
    var isWhite = !transparent || searchFocused || overlayOpen || scrolled;
    header.classList.toggle('is-white', isWhite);
    header.classList.toggle('is-hidden', !visible);
    header.classList.toggle('is-search-focused', searchFocused);
    header.classList.toggle('is-mega-open', overlayOpen);

    if (megaToggle) megaToggle.setAttribute('aria-expanded', overlayOpen ? 'true' : 'false');
    if (backdrop) backdrop.classList.toggle('is-open', overlayOpen);

    if (megaMenu) {
      megaMenu.classList.toggle('is-open', overlayOpen);
      megaMenu.setAttribute('aria-hidden', overlayOpen ? 'false' : 'true');
    }

    var panelShown = !!activeGroupId && overlayOpen && panelVisible;
    if (megaPanel) {
      megaPanel.classList.toggle('is-visible', panelShown);
      megaPanel.setAttribute('aria-hidden', panelShown ? 'false' : 'true');
    }
    groupButtons.forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-mega-group') === activeGroupId);
    });
    panes.forEach(function (pane) {
      pane.classList.toggle('is-active', pane.getAttribute('data-mega-pane') === activeGroupId);
    });

    if (drawer) {
      drawer.classList.toggle('is-open', mobileOpen);
      drawer.classList.toggle('is-group-active', !!mobileGroupId);
      drawerPanes.forEach(function (pane) {
        pane.classList.toggle('is-active', pane.getAttribute('data-drawer-pane') === mobileGroupId);
      });
    }
    if (drawerBackdrop) drawerBackdrop.classList.toggle('is-open', mobileOpen);
    if (drawerOpenBtn) drawerOpenBtn.setAttribute('aria-expanded', mobileOpen ? 'true' : 'false');

    if (mobileSearch) {
      mobileSearch.classList.toggle('is-open', mobileSearchOpen);
      mobileSearch.setAttribute('aria-hidden', mobileSearchOpen ? 'false' : 'true');
    }
    if (mobileSearchBtn) mobileSearchBtn.setAttribute('aria-expanded', mobileSearchOpen ? 'true' : 'false');

    if (mobileOpen || overlayOpen || mobileSearchOpen) window.Dylys.lockScroll(); else window.Dylys.unlockScroll();
  }

  function closeAll() {
    overlayOpen = false;
    activeGroupId = null;
    panelVisible = false;
    mobileOpen = false;
    mobileGroupId = null;
    mobileSearchOpen = false;
    render();
  }

  // Scroll: direction + threshold (exact port of the onScroll handler)
  window.addEventListener(
    'scroll',
    function () {
      // iOS fires scroll events when the keyboard opens — must not dismiss
      // the search overlay (or hide the header underneath it)
      if (mobileSearchOpen) return;
      var y = window.scrollY;
      var up = y < lastScrollY;
      var show = y < 10 || up;
      scrolled = y > 10;
      visible = show;
      if (!show) {
        overlayOpen = false;
        activeGroupId = null;
        mobileOpen = false;
        mobileGroupId = null;
      }
      lastScrollY = y;
      render();
    },
    { passive: true }
  );

  // Escape closes everything (same subset of state as the React handler)
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      overlayOpen = false;
      activeGroupId = null;
      mobileOpen = false;
      mobileGroupId = null;
      mobileSearchOpen = false;
      render();
    }
  });

  // PRODUKTE toggle
  if (megaToggle) {
    megaToggle.addEventListener('click', function () {
      overlayOpen = !overlayOpen;
      if (overlayOpen) {
        activeGroupId = null;
        panelVisible = false;
        if (panelTimer) clearTimeout(panelTimer);
      }
      render();
    });
  }

  // Group open with the 120ms crossfade
  groupButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-mega-group');
      if (panelTimer) clearTimeout(panelTimer);
      if (activeGroupId && activeGroupId !== id) {
        panelVisible = false;
        render();
        panelTimer = setTimeout(function () {
          activeGroupId = id;
          panelVisible = true;
          render();
        }, 120);
        return;
      }
      activeGroupId = id;
      render();
      window.requestAnimationFrame(function () {
        panelVisible = true;
        render();
      });
    });
  });

  // Search expand/collapse
  if (searchInput) {
    searchInput.addEventListener('focus', function () {
      searchFocused = true;
      overlayOpen = false;
      activeGroupId = null;
      render();
    });
    searchInput.addEventListener('blur', function () {
      if (!searchInput.value) {
        searchFocused = false;
        render();
      }
    });
  }

  // Backdrops close everything
  if (backdrop) backdrop.addEventListener('click', closeAll);
  if (drawerBackdrop) drawerBackdrop.addEventListener('click', closeAll);

  // Mobile drawer
  if (drawerOpenBtn) {
    drawerOpenBtn.addEventListener('click', function () {
      mobileOpen = true;
      mobileGroupId = null;
      render();
    });
  }
  // Mobile search icon opens the full-screen search overlay. focus() must
  // run synchronously in the tap handler, or iOS keeps the keyboard closed.
  if (mobileSearchBtn) {
    mobileSearchBtn.addEventListener('click', function () {
      mobileSearchOpen = true;
      mobileOpen = false;
      mobileGroupId = null;
      render();
      if (mobileSearchInput) mobileSearchInput.focus({ preventScroll: true });
    });
  }
  if (mobileSearchCloseBtn) {
    mobileSearchCloseBtn.addEventListener('click', function () {
      mobileSearchOpen = false;
      render();
      if (mobileSearchInput) mobileSearchInput.blur();
    });
  }
  if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeAll);
  if (drawerBackBtn) {
    drawerBackBtn.addEventListener('click', function () {
      mobileGroupId = null;
      render();
    });
  }
  drawerGroupBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      mobileGroupId = btn.getAttribute('data-drawer-group');
      render();
    });
  });

  // Any element marked data-nav-close (logo, nav links, overlay links) closes all
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-nav-close]')) closeAll();
  });

  render();
})();
